import Modal from "components/ui/Modal";
import Button from "components/ui/Button";
import { formatCurrency } from "utils/helperFunctions";

// Modeled on beleef-frontend's ScheduleCampaign.js "Send Cart" confirmation —
// short declarative sentence(s) stating the dollar impact, then a bolded
// consequence sentence, Cancel/Confirm buttons. Unlike the agent-facing cart
// (silent on success), this shows a toast either way — an admin correcting a
// live funding record needs explicit confirmation it worked.
const CartConfirmModal = ({ isOpen, onClose, onConfirm, isSaving, previousTotal, newTotal, cfLinked }) => {
  const delta = newTotal - previousTotal;

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Confirm Cart Correction" className="max-w-md">
      <div className="space-y-4">
        <p className="text-sm">
          Cart total will change from <strong>{formatCurrency(previousTotal)}</strong> to{" "}
          <strong>{formatCurrency(newTotal)}</strong>
          {delta !== 0 && (
            <>
              {" "}({delta > 0 ? "+" : ""}
              {formatCurrency(delta)})
            </>
          )}
          .
        </p>
        {cfLinked ? (
          <p className="text-sm font-medium">
            Confirming this will also update Campaign Flow's budget for this campaign to match — the
            vendor will be asked to fund the corrected amount instead of the original.
          </p>
        ) : (
          <p className="text-sm font-medium">
            This cart hasn't been sent to Campaign Flow yet, so confirming just saves the cart —
            nothing external is notified.
          </p>
        )}
        <div className="flex justify-end gap-2">
          <Button className="outline-button" onClick={onClose} disabled={isSaving}>
            Cancel
          </Button>
          <Button className="black-button" onClick={onConfirm} disabled={isSaving} loading={isSaving}>
            Confirm Correction
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default CartConfirmModal;
